import { render, staticRenderFns } from "./QRECE.vue?vue&type=template&id=ba484382&scoped=true"
import script from "./QRECE.vue?vue&type=script&lang=js"
export * from "./QRECE.vue?vue&type=script&lang=js"
import style0 from "./QRECE.vue?vue&type=style&index=0&id=ba484382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba484382",
  null
  
)

export default component.exports